/* unplugin-vue-components disabled */import { render } from "./BeneficiaryToOwnerUpgrade.vue?vue&type=template&id=2e8160db"
import script from "./BeneficiaryToOwnerUpgrade.vue?vue&type=script&lang=js"
export * from "./BeneficiaryToOwnerUpgrade.vue?vue&type=script&lang=js"

import "./BeneficiaryToOwnerUpgrade.vue?vue&type=style&index=0&id=2e8160db&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__